import AirbusPhoto from './assets/airbus-photo.webp';
import AmazonPhoto from './assets/amazon-photo.webp';
import AokPhoto from './assets/aok-photo.webp';
import AudiPhoto from './assets/audi-photo.webp';
import BahneGrothPhoto from './assets/bahne-groth-photo.webp';
import BasfPhoto from './assets/basf-photo.webp';
import BdoPhoto from './assets/bdo-photo.webp';
import BechtlePhoto from './assets/bechtle-photo.webp';
import BmwPhoto from './assets/bmw-photo.webp';
import BoschPhoto from './assets/bosch-photo.webp';
import CarolaLudewigPhoto from './assets/carola-ludewig-photo.webp';
import DeutscheBahnPhoto from './assets/db-photo.webp';
import DeutscheBankPhoto from './assets/deutsche-bank-photo.webp';
import DeutschePostPhoto from './assets/deutsche-post.webp';
import DisPhoto from './assets/dis-photo.webp';
import DmPhoto from './assets/dm-photo.webp';
import DsvPhoto from './assets/dsv-photo.webp';
import DuerenhoffPhoto from './assets/duerenhoff-photo.webp';
import EdekaPhoto from './assets/edeka-photo.webp';
import FatmaKocPhoto from './assets/fatma-koc-photo.webp';
import FinjaPhoto from './assets/finja-struber.256x256.webp';
import FlaschenpostPhoto from './assets/flaschenpost-photo.webp';
import HaysPhoto from './assets/hays-photo.webp';
import HolmesPhoto from './assets/holmes-photo.webp';
import HuseyinYalcinPhoto from './assets/huseyin-photo.webp';
import IkeaPhoto from './assets/ikea-photo.webp';
import IsabelStruschkaPhoto from './assets/isabel-photo.webp';
import JanPhoto from './assets/jan-gotze.256x256.webp';
import JanSchengberPhoto from './assets/jan-schengber-photo.webp';
import JohannaPhoto from './assets/johanna-eckert.256x256.webp';
import JonasPhoto from './assets/jonas-masanneck.256x256.webp';
import JuliaReichhoferPhoto from './assets/julia-reichhofer-photo.webp';
import KauflandPhoto from './assets/kaufland-photo.webp';
import KosterPhoto from './assets/koster-photo.webp';
import KrakenhausPhoto from './assets/krakenhaus-photo.webp';
import KristinPhoto from './assets/kristin-semelka.256x256.webp';
import LidlPhoto from './assets/lidl-photo.webp';
import MaltePhoto from './assets/malte-balmer.256x256.webp';
import MariaPhoto from './assets/maria-heucke.256x256.webp';
import MeinestadtPhoto from './assets/meinestadt-photo.webp';
import MigrosPhoto from './assets/migros-photo.webp';
import MiriamPhoto from './assets/miriam--djambou.256x256.webp';
import OetkerPhoto from './assets/oetker-photo.webp';
import OnlyFyPhoto from './assets/onlyfy-photo.webp';
import OttoPhoto from './assets/otto-photo.webp';
import OttobockPhoto from './assets/ottobock-photo.webp';
import PorschePhoto from './assets/porsche-photo.webp';
import PwcPhoto from './assets/pwc-photo.webp';
import RalphOstermeierPhoto from './assets/ralph-ostermeier-photo.webp';
import RewePhoto from './assets/rewe-photo.webp';
import RobinMaurerPhoto from './assets/robin-maurer-photo.webp';
import RossmanPhoto from './assets/rossman-photo.webp';
import SapPhoto from './assets/sap-photo.webp';
import SarahPhoto from './assets/sarah-baudzus.256x256.webp';
import SchmersalPhoto from './assets/schmersal-photo.webp';
import SiemensPhoto from './assets/siemens-photo.webp';
import StephaniePhoto from './assets/stefanie-klock.256x256.webp';
import TerbergPhoto from './assets/terberg-photo.webp';
import VanessaPhoto from './assets/vanessa-strauch.256x256.webp';
import VeronikaPhoto from './assets/veronika-gersdorf.256x256.webp';

export const CompanyRecruitersData = [
  {
    id: 1,
    photoUrl: FinjaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Finja Strüber',
    companyLogo: RossmanPhoto,
    jobTitle: 'Talent Acquisition & Employer Branding',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER',
    company: 'Dirk Rossmann',
    profileUrl: 'https://www.xing.com/profile/Finja_Strueber',
  },
  {
    id: 2,
    photoUrl: MaltePhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Malte Balmer',
    companyLogo: OttoPhoto,
    jobTitle: 'Senior HR Manager Recruiting',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER',
    company: 'OTTO',
    profileUrl: 'https://www.xing.com/profile/Malte_Balmer',
  },
  {
    id: 3,
    photoUrl: JanPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Jan Götze',
    companyLogo: DeutscheBahnPhoto,
    jobTitle: 'Leiter Active Sourcing IT-Akademiker·innen',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE',
    company: 'DB',
    profileUrl: 'https://www.xing.com/profile/Jan_Goetze8',
  },
  {
    id: 4,
    photoUrl: StephaniePhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Stefanie Klöck',
    companyLogo: HaysPhoto,
    jobTitle: 'Senior Active Sourcing Specialist',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK',
    company: 'Hays',
    profileUrl: 'https://www.xing.com/profile/Stefanie_Kloeck',
  },
  {
    id: 5,
    photoUrl: JohannaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Johanna Eckert',
    companyLogo: BdoPhoto,
    jobTitle: 'Recruiting Specialist',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT',
    company: 'BDO',
    profileUrl: 'https://www.xing.com/profile/Johanna_Eckert6',
  },
  {
    id: 6,
    photoUrl: MiriamPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Miriam Djambou',
    companyLogo: DisPhoto,
    jobTitle: 'Recruiterin',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU',
    company: 'DIS AG',
    profileUrl: 'https://www.xing.com/profile/Miriam_Djambou042705',
  },
  {
    id: 7,
    photoUrl: SarahPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Sarah Baudzus',
    companyLogo: KrakenhausPhoto,
    jobTitle: 'Recruiterin',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS',
    company: 'Krankenhaus Reinbek St. Adolf-Stift',
    profileUrl: 'https://www.xing.com/profile/Sarah_Baudzus',
  },
  {
    id: 8,
    photoUrl: KristinPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Kristin Semelka',
    companyLogo: TerbergPhoto,
    jobTitle: 'Recruiting',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA',
    company: 'TERBERG Spezialfahrzeuge',
    profileUrl: 'https://www.xing.com/profile/Kristin_Semelka',
  },
  {
    id: 9,
    photoUrl: MariaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Maria Heucke',
    companyLogo: OttobockPhoto,
    jobTitle: 'Recruiterin',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE',
    company: 'Ottobock',
    profileUrl: 'https://www.xing.com/profile/Maria_Heucke',
  },
  {
    id: 10,
    photoUrl: VanessaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Vanessa Strauch',
    companyLogo: DsvPhoto,
    jobTitle: 'Recruiting Specialist DACH',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH',
    company: 'DSV',
    profileUrl: 'https://www.xing.com/profile/Vanessa_Strauch15',
  },
  {
    id: 11,
    photoUrl: JonasPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Jonas Masanneck',
    companyLogo: OnlyFyPhoto,
    jobTitle: 'Recruiting Consultant',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK',
    company: 'onlyfy TalentService',
    profileUrl: 'https://www.xing.com/profile/Jonas_Masanneck',
  },
  {
    id: 12,
    photoUrl: VeronikaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Veronika Gersdorf',
    companyLogo: HolmesPhoto,
    jobTitle: 'Recruiting & Employer Branding Specialist',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF',
    company: 'Holmes Place',
    profileUrl: 'https://www.xing.com/profile/Veronika_Gersdorf',
  },
  {
    id: 13,
    photoUrl: RalphOstermeierPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Ralph Ostermeier',
    companyLogo: EdekaPhoto,
    jobTitle: 'Tech Recruiter',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER',
    company: 'EDEKA DIGITAL',
    profileUrl: 'https://www.xing.com/profile/Ralph_Ostermeier/',
  },
  {
    id: 14,
    photoUrl: JanSchengberPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Jan Schengber',
    companyLogo: KosterPhoto,
    jobTitle: 'HR Manager',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER',
    company: 'Köster GmbH',
    profileUrl: 'https://www.xing.com/profile/Jan_Schengber',
  },
  {
    id: 15,
    photoUrl: HuseyinYalcinPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Hüseyin Yalcin',
    companyLogo: BechtlePhoto,
    jobTitle: 'Teamkoordinator Active Sourcing',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN',
    company: 'Bechtle',
    profileUrl: 'https://www.xing.com/profile/Hueseyin_Yalcin24/',
  },
  {
    id: 16,
    photoUrl: FatmaKocPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Fatma Koc',
    companyLogo: PwcPhoto,
    jobTitle: 'Associate - Talent Acquisition',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC',
    company: 'PwC Deutschland',
    profileUrl: 'https://www.xing.com/profile/FatmaGuel_Koc3/',
  },
  {
    id: 17,
    photoUrl: RobinMaurerPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Robin Maurer',
    companyLogo: MigrosPhoto,
    jobTitle: 'Teamleiter Recruiting',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER',
    company: 'Migros',
    profileUrl: 'https://www.xing.com/profile/Robin_Maurer10',
  },
  {
    id: 18,
    photoUrl: BahneGrothPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Bahne Groth',
    companyLogo: FlaschenpostPhoto,
    jobTitle: 'Talent Acquisition Manager',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH',
    company: 'flaschenpost SE',
    profileUrl: 'https://www.xing.com/profile/Bahne_Groth2',
  },
  {
    id: 19,
    photoUrl: IsabelStruschkaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Isabel Struschka',
    companyLogo: OetkerPhoto,
    jobTitle: 'Professional Process & Recruiting',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA',
    company: 'Dr. Oetker',
    profileUrl: 'https://www.xing.com/profile/Isabel_Struschka/',
  },
  {
    id: 20,
    photoUrl: CarolaLudewigPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Carola Ludewig',
    companyLogo: AmazonPhoto,
    jobTitle: 'Talent Acquisition Candidate Partner (TACP)',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG',
    company: 'Amazon',
    profileUrl: 'https://www.xing.com/profile/Carola_Ludewig/',
  },
  {
    id: 21,
    photoUrl: JuliaReichhoferPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_RECRUITERS',
    name: 'Julia Reichhofer',
    companyLogo: SchmersalPhoto,
    jobTitle: 'Senior Recruiter',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER',
    company: 'K.A. Schmersal GmbH & Co. KG',
    profileUrl: 'https://www.xing.com/profile/Julia_Reichhofer',
  },
  {
    id: 22,
    photoUrl: AmazonPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.3,
    name: 'Amazon',
    jobTitle: '> 10.000 Mitarbeitende; 24.390 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON',
    profileUrl: 'https://www.xing.com/pages/amazon',
  },
  {
    id: 23,
    photoUrl: DmPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.6,
    name: 'dm',
    jobTitle: '> 10.000 Mitarbeitende; 12.155 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM',
    profileUrl: 'https://www.xing.com/pages/dm',
  },
  {
    id: 24,
    photoUrl: LidlPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.8,
    name: 'Lidl',
    jobTitle: '> 10.000 Mitarbeitende; 25.859 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL',
    profileUrl: 'https://www.xing.com/pages/lidl',
  },
  {
    id: 25,
    photoUrl: DeutscheBahnPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.8,
    name: 'Deutsche Bahn',
    jobTitle: '> 10.000 Mitarbeitende; 72.157 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN',
    profileUrl: 'https://www.xing.com/pages/deutschebahn',
  },
  {
    id: 26,
    photoUrl: PorschePhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    name: 'Porsche',
    jobTitle: '> 10.000 Mitarbeitende; 56.698 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE',
    profileUrl: 'https://www.xing.com/pages/dr-ing-h-c-f-porscheag',
  },
  {
    id: 27,
    photoUrl: RossmanPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.5,
    name: 'ROSSMANN',
    jobTitle: '> 10.000 Mitarbeitende; 6.766 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN',
    profileUrl: 'https://www.xing.com/pages/dirkrossmanngmbh',
  },
  {
    id: 28,
    photoUrl: BmwPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.9,
    name: 'BMW',
    jobTitle: '> 10.000 Mitarbeitende; 95.398 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW',
    profileUrl: 'https://www.xing.com/pages/bmwgroup',
  },
  {
    id: 29,
    photoUrl: RewePhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.4,
    name: 'REWE',
    jobTitle: '> 10.000 Mitarbeitende; 19.527 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE',
    profileUrl: 'https://www.xing.com/pages/rewe',
  },
  {
    id: 30,
    photoUrl: SiemensPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.7,
    name: 'Siemens',
    jobTitle: '> 10.000 Mitarbeitende; 117.771 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS',
    profileUrl: 'https://www.xing.com/pages/siemensag',
  },
  {
    id: 31,
    photoUrl: MeinestadtPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.2,
    name: 'meinestadt.de',
    jobTitle: '201-500 Mitarbeitende; 1.049 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE',
    profileUrl: 'https://www.xing.com/pages/meinestadt-de',
  },
  {
    id: 32,
    photoUrl: BoschPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.9,
    name: 'Bosch',
    jobTitle: '> 10.000 Mitarbeitende; 94.783 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH',
    profileUrl: 'https://www.xing.com/pages/boschgruppe',
  },
  {
    id: 33,
    photoUrl: KauflandPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.2,
    name: 'Kaufland',
    jobTitle: '> 10.000 Mitarbeitende; 14.661 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND',
    profileUrl: 'https://www.xing.com/pages/kaufland',
  },
  {
    id: 34,
    photoUrl: AirbusPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.7,
    name: 'Airbus',
    jobTitle: '> 10.000 Mitarbeitende; 37.311 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS',
    profileUrl: 'https://www.xing.com/pages/airbus',
  },
  {
    id: 35,
    photoUrl: DeutschePostPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.8,
    name: 'Deutsche Post',
    jobTitle: '> 10.000 Mitarbeitende; 31.815 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST',
    profileUrl: 'https://www.xing.com/pages/deutschepostag',
  },
  {
    id: 36,
    photoUrl: BasfPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.6,
    name: 'BASF',
    jobTitle: '> 10.000 Mitarbeitende; 35.560 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF',
    profileUrl: 'https://www.xing.com/pages/basf',
  },
  {
    id: 37,
    photoUrl: IkeaPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.6,
    name: 'IKEA',
    jobTitle: '> 10.000 Mitarbeitende; 9.755 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA',
    profileUrl: 'https://www.xing.com/pages/ikeadeutschland',
  },
  {
    id: 38,
    photoUrl: SapPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 4.4,
    name: 'SAP',
    jobTitle: '> 10.000 Mitarbeitende; 45.608 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP',
    profileUrl: 'https://www.xing.com/pages/sap',
  },
  {
    id: 39,
    photoUrl: AudiPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.9,
    name: 'Audi',
    jobTitle: '> 10.000 Mitarbeitende; 61.318 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI',
    profileUrl: 'https://www.xing.com/pages/audiag',
  },
  {
    id: 40,
    photoUrl: AokPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.9,
    name: 'AOK',
    jobTitle: '> 10.000 Mitarbeitende; 10.306 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK',
    profileUrl: 'https://www.xing.com/pages/aok',
  },
  {
    id: 41,
    photoUrl: DuerenhoffPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 4.8,
    name: 'duerenhoff GmbH',
    jobTitle: '11-50 Mitarbeitende; 607 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH',
    profileUrl: 'https://www.xing.com/pages/duerenhoffgmbh',
  },
  {
    id: 42,
    photoUrl: DeutscheBankPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    rating: 3.5,
    name: 'Deutsche Bank',
    jobTitle: '> 10.000 Mitarbeitende; 30.387 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK',
    profileUrl: 'https://www.xing.com/pages/deutschebankag',
  },
  {
    id: 43,
    photoUrl: OttobockPhoto,
    flagText: 'RECRUITERS_SECTION_FLAG_COMPANIES',
    ratng: 3.7,
    name: 'Ottobock',
    jobTitle: '> 5.000 Mitarbeitende; 3.097 Follower',
    insight: 'LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK',
    profileUrl: 'https://www.xing.com/pages/ottobockse-co-kgaa',
  },
];
